import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "image-block__text" }
const _hoisted_2 = ["textContent"]
const _hoisted_3 = { class: "image-block__text__action" }
const _hoisted_4 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "image-block flex flex-align-end pa-4",
    style: _normalizeStyle({ "background-image": `url(${_ctx.imageUrl})`}),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.navigate && _ctx.navigate(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: "image-block__text__title roboto-slab mb",
        textContent: _toDisplayString(_ctx.$t("DASHBOARD.SUPPORT_BLOCK.TITLE"))
      }, null, 8, _hoisted_2),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          textContent: _toDisplayString(_ctx.$t("DASHBOARD.SUPPORT_BLOCK.ACTION"))
        }, null, 8, _hoisted_4),
        _cache[1] || (_cache[1] = _createElementVNode("i", { class: "icons8-forward ml-025" }, null, -1))
      ])
    ])
  ], 4))
}